module.exports = __webpack_public_path__ + "media/images/admin2/AdminForm__status__panel__a-cc7d11b1d3b1f15348e2a26a9d244163.svg";